import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiLoader } from 'react-icons/fi';

const FunnelProxy = () => {
    const { subdomain, funnelId: urlFunnelId, stepId: urlStepId } = useParams();
    const [htmlContent, setHtmlContent] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFunnelPage = async () => {
            try {
                if (!subdomain) {
                    setError('Invalid funnel domain');
                    return;
                }

                const funnelId = urlFunnelId || 'home';
                const stepId = urlStepId || 'index';

                const { supabaseUrl } = await import('../../supabase');
                const url = `${supabaseUrl}/functions/v1/serve-funnel?subdomain=${subdomain}&funnelId=${funnelId}&stepId=${stepId}`;

                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Page not found');
                }

                let text = await response.text();

                // Clean up any stray markdown wrappers that might be present
                text = text.replace(/^```html\s*/i, '').replace(/```\s*$/i, '');

                // Use document.write to completely replace the document and evaluate scripts.
                // This is the most reliable way to render dynamic HTML content with Tailwind CDN.
                document.open();
                document.write(text);
                document.close();

            } catch (err) {
                console.error(err);
                setError('Page not found');
            }
        };

        fetchFunnelPage();
    }, []);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-charcoal-50 text-charcoal-900">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-bold">404</h1>
                    <p className="text-lg text-charcoal-600">The requested page could not be found.</p>
                    <a href="https://app.sevenhats.com" className="text-primary-600 hover:underline">Go to SEVEN HATS</a>
                </div>
            </div>
        );
    }



    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <FiLoader className="animate-spin text-4xl text-charcoal-300" />
        </div>
    );
};

export default FunnelProxy;
